import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
} from "react-bootstrap-table";
import { FormGroup } from "semantic-ui-react";
import { Button, Modal, ControlLabel, FormControl } from "react-bootstrap";
import _ from "lodash";
import NotificationSystem from "react-notification-system";
import { style } from "../../variables/Variables";

// Css
import "../../assets/css/grantaccesstables.css";

import LocalizedStrings from "react-localization";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    groupNameHeader: "Group Name",
    selectGroupBtn: "Select Group",
    editGroupBtn: "Edit Group",
    popUpTitle: "Groups",
    selectGroupsLabel: "Select Groups",
    nameHeader: "Name",
    groupListLabel: "Group List",
    okBtn: "OK",
    cancelBtn: "Cancel",
    noDataTitle: "There is no data to display",
    searchPlaceholder: "Search",
    selectGroup: "Please select at least one group",
  },
  ja: {
    groupNameHeader: "グループ名",
    selectGroupBtn: "グループ選択",
    editGroupBtn: "グループ編集",
    popUpTitle: "グループ",
    selectGroupsLabel: "グループ選択",
    nameHeader: "名前",
    groupListLabel: "グループリスト",
    okBtn: "OK",
    cancelBtn: "キャンセル",
    noDataTitle: "表示するデータがありません。",
    searchPlaceholder: "検索",
    selectGroup: "少なくとも 1 つのグループを選択してください",
  },
  es: {
    groupNameHeader: "Nombre del Grupo",
    selectGroupBtn: "Seleccionar Grupo",
    editGroupBtn: "Editar Grupo",
    popUpTitle: "Grupos",
    selectGroupsLabel: "Seleccionar Grupos",
    nameHeader: "Nombre",
    groupListLabel: "Lista de Grupos",
    okBtn: "OK",
    cancelBtn: "Cancelar",
    noDataTitle: "No hay datos para mostrar",
    searchPlaceholder: "Buscar",
    selectGroup: "Por favor seleccione al menos un grupo",
  },
});

class GroupsTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showPopup: false,
      groupListArray: [],
      addedGroups: [],
      selectedGroups: [],
      _notificationSystem: null,
    };

    this.handleInsertButtonClick = this.handleInsertButtonClick.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.createCustomSearchFieldForm = this.createCustomSearchFieldForm.bind(
      this
    );
    this.renderSelectGroup = this.renderSelectGroup.bind(this);
    this.unselectGroup = this.unselectGroup.bind(this);
    this.handlePopupSubmit = this.handlePopupSubmit.bind(this);
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  componentWillMount() {
    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  createCustomInsertButton = (onClick) => {
    return (
      <button
        className="selectGroupBtn"
        onClick={() => this.handleInsertButtonClick(onClick)}
      >
        <i className="fa fa-users" style={{ marginRight: "2px" }} />{" "}
        {this.state.selectedGroups.length > 0
          ? localizationStrings.editGroupBtn
          : localizationStrings.selectGroupBtn}
      </button>
    );
  };

  handleInsertButtonClick() {
    const allGroups = [];
    const addedGroupsID = [];
    const selectedGroups = [];

    for (var i = 0; i < this.state.addedGroups.length; i++) {
      const eachAddedGroupID = this.state.addedGroups[i].groupID;

      addedGroupsID.push(eachAddedGroupID);
    }

    for (var a = 0; a < this.props.groupList.length; a++) {
      const eachGroup = this.props.groupList[a];

      if (!addedGroupsID.includes(eachGroup.groupID)) {
        allGroups.push(eachGroup);
      }
    }

    for (var b = 0; b < this.props.selectedGroups.length; b++) {
      const eachSelectedGroup = this.props.selectedGroups[b];

      selectedGroups.push(eachSelectedGroup);
    }

    this.setState({
      showPopup: true,
      groupListArray: allGroups,
      selectedGroups: selectedGroups,
    });
  }

  handlePopupClose() {
    const addedGroupArray = [];

    for (var i = 0; i < this.state.selectedGroups.length; i++) {
      const eachSelectedGroup = this.state.selectedGroups[i];

      addedGroupArray.push(eachSelectedGroup);
    }

    this.setState({
      showPopup: false,
      addedGroups: addedGroupArray,
    });
  }

  createCustomSearchFieldForm() {
    return (
      <SearchField
        // style={{ color: "blue" }}
        className="formSearchBar"
        // id="retractSearch"
        placeholder={localizationStrings.searchPlaceholder}
      />
    );
  }

  renderSelectGroup(cell, row) {
    return (
      <div>
        <button
          className={"select-btn"}
          onClick={(e) => {
            e.preventDefault();

            const allGroupsArrayList = this.state.groupListArray;
            const addedGroupsArrayList = this.state.addedGroups;

            addedGroupsArrayList.push(row);
            allGroupsArrayList.splice(allGroupsArrayList.indexOf(row), 1);

            this.setState({
              groupListArray: allGroupsArrayList,
              addedGroups: addedGroupsArrayList,
            });
          }}
        >
          <span className="plusIcon">&#43;</span>
        </button>
      </div>
    );
  }

  unselectGroup(cell, row) {
    return (
      <div>
        <button
          className={"unselect-btn"}
          onClick={(e) => {
            e.preventDefault();

            const allGroupsArrayList = this.state.groupListArray;
            const addedGroupsArrayList = this.state.addedGroups;

            allGroupsArrayList.push(row);
            addedGroupsArrayList.splice(addedGroupsArrayList.indexOf(row), 1);

            this.setState({
              groupListArray: allGroupsArrayList,
              addedGroups: addedGroupsArrayList,
            });
          }}
        >
          <span className="crossIcon">&times;</span>
        </button>
      </div>
    );
  }

  handlePopupSubmit() {
    if (this.state.addedGroups.length <= 0) {
      this.showNotification(`${localizationStrings.selectGroup}`, "error", 5);
      return;
    }

    const confirmedGroups = [];

    for (var i = 0; i < this.state.addedGroups.length; i++) {
      const eachAddedGroup = this.state.addedGroups[i];

      confirmedGroups.push(eachAddedGroup);
    }

    this.props.dataCallBack(confirmedGroups);

    this.setState({
      showPopup: false,
      selectedGroups: confirmedGroups,
    });
  }

  showNotification(msg, lvl, dismissal, allowDismiss) {
    let dismissalAllowed = false;

    if (allowDismiss === "") {
      dismissalAllowed = true;
    }

    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        ></span>
      ),
      message: <div>{msg}</div>,
      level: lvl,
      position: "tc",
      autoDismiss: dismissal,
      dismissible: dismissalAllowed,
    });
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }
    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
        {/* {this.props.visible && (
          <BootstrapTable data={this.props.selectedGroups} bordered={false}>
            <TableHeaderColumn
              hidden
              dataField="groupID"
              isKey={true}
              tdStyle={{ textAlign: "center" }}
              thStyle={{ textAlign: "center" }}
            >
              Group ID
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="groupName"
              tdStyle={{ textAlign: "center" }}
              thStyle={{ textAlign: "center" }}
            >
              Group Name
            </TableHeaderColumn>
          </BootstrapTable>
        )} */}
        {this.props.visible && (
          <BootstrapTable
            className="grantAccessSelectTable"
            data={this.state.selectedGroups}
            bordered={false}
            pagination
            options={{
              sizePerPage: 5,
              hideSizePerPage: true,
              insertBtn: this.createCustomInsertButton,
              noDataText: localizationStrings.noDataTitle,
            }}
            insertRow
            tableStyle={{ border: "4px solid black", borderRadius: "12px" }}
          >
            <TableHeaderColumn
              hidden
              dataField="groupID"
              isKey={true}
              tdStyle={{ textAlign: "center" }}
              thStyle={{ textAlign: "center" }}
            >
              Group ID
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="groupName"
              tdStyle={{ textAlign: "center" }}
              thStyle={{ textAlign: "center" }}
            >
              {localizationStrings.groupNameHeader}
            </TableHeaderColumn>
          </BootstrapTable>
        )}
        {/* //! Popup for Select Group Button */}
        <Modal
          show={this.state.showPopup}
          onHide={this.handlePopupClose}
          dialogClassName="modal-70w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.popUpTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "30px 30px 40px 30px" }}>
            <div className="selectMembersTable">
              <ControlLabel style={{ fontSize: "1.2em" }}>
                {localizationStrings.selectGroupsLabel}
              </ControlLabel>
              <BootstrapTable
                data={this.state.groupListArray}
                bordered={false}
                pagination
                options={{
                  sizePerPage: 5,
                  hideSizePerPage: true,
                  searchField: this.createCustomSearchFieldForm,
                  defaultSortName: "groupName", // default sort column name
                  defaultSortOrder: "asc", // default sort order
                  noDataText: localizationStrings.noDataTitle,
                }}
                search
              >
                <TableHeaderColumn
                  hidden
                  dataField="groupID"
                  isKey={true}
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  ID
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="groupName"
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  {localizationStrings.nameHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataFormat={this.renderSelectGroup}
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                ></TableHeaderColumn>
              </BootstrapTable>
              <ControlLabel style={{ fontSize: "1.2em" }}>
                {localizationStrings.groupListLabel}
              </ControlLabel>
              <BootstrapTable
                data={this.state.addedGroups}
                bordered={false}
                pagination
                options={{
                  sizePerPage: 5,
                  hideSizePerPage: true,
                  noDataText: localizationStrings.noDataTitle,
                }}
              >
                <TableHeaderColumn
                  hidden
                  dataField="groupID"
                  isKey={true}
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  ID
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="groupName"
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  {localizationStrings.nameHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataFormat={this.unselectGroup}
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                ></TableHeaderColumn>
              </BootstrapTable>
            </div>
            <FormGroup style={{ display: "flex" }}>
              <Button
                style={{ marginRight: "10px" }}
                onClick={this.handlePopupSubmit}
              >
                {localizationStrings.okBtn}
              </Button>
              <Button
                style={{ marginLeft: "10px" }}
                onClick={this.handlePopupClose}
              >
                {localizationStrings.cancelBtn}
              </Button>
            </FormGroup>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default GroupsTable;
